import Vue from 'vue'
import Router from 'vue-router'
import {Rt} from './routeHelp'

/**
 * 树形二级菜单子路由
 */
let treeChildren = [
    // 示例
    Rt.page( "examples/form", "examples/form/index", '表单案例'),
    Rt.page( "examples/table", "examples/zl-table/index", '对象表格案例'),
    Rt.page( "examples/table1", "examples/zl-table-1/index", '对象表格案例'),
    Rt.page( "examples/zl-table-tabs", "examples/zl-table-tabs/index", '包含标签页的表格例子'),


    //尾程订单费用明细
    Rt.page( "fastTransferOrder/commission/costDetail", "commission/costDetail/index", '费用明细').setProps({module:2,sourceType:'FAST_TRANSFER_ORDER'}),
    Rt.page( "wcOrder/qgxx", "wc/wcQgxx/index", '清关信息').setProps({module:2}),
    Rt.page( "wcOrder/order", "commission/wcOrder/index", '尾程订单').setProps({module:2}),
    Rt.page( "wcOrder/wcbjOrder", "commission/wcbjOrder/index", '尾程报价单').setProps({module:2}),
    Rt.page( "wcOrder/wcpsOrder", "commission/wcpsOrder/index", '尾程派送订单').setProps({module:2}),
    Rt.page( "wcOrder/inquiryRecord", "commission/inquiryRecord/index", '询价记录').setProps({module:2}),
    Rt.page( "wcOrder/abnormal", "commission/abnormalOrder/index", '尾程异常订单').setProps({module:2,abnormalRecordType:1}),
    Rt.page( "order/commission", "commission/commissionOrder/index", '委托单管理').setProps({module:1}),
    Rt.page( "order/quotation", "commission/quotationOrder/index", '报价单管理','quotation').setProps({module:1}),
    Rt.page( "commission/report", "commission/report/index", '报关信息').setProps({module:1}),
    Rt.page( "commission/billInfo", "commission/billInfo/index", '提单信息').setProps({module:1}),
    Rt.page( "commission/measurements", "commission/measurements/index", '进仓信息').setProps({module:1}),
    Rt.page( "commission/dstDeclaration", "commission/dstDeclaration/index", '目的国申报').setProps({module:1}),
    Rt.page( "commission/costDetail", "commission/costDetail/index", '费用明细').setProps({module:1,sourceType:"COMMISSION_ORDER"}),
    Rt.page( "commission/clearance", "commission/clearance/index", '清关信息').setProps({module:1}),
    Rt.page( "commission/fastTransferOrder", "commission/fastTransferOrder/index", '尾程订单(旧)'),
    Rt.page( "commission/deliveryTransferOrder", "commission/deliveryTransferOrder/index", '尾程派送订单(旧)'),
    Rt.page( "commission/abnormalOrder", "commission/abnormalOrder/index", '尾程异常订单(旧)').setProps({module:2,abnormalRecordType:0}),
    Rt.page( "commission/inquiryRecord", "commission/inquiryRecord/index", '询价记录').setProps({module:1}),
    Rt.page( "commission/loadingFullContainer", "commission/loadingFullContainer/index", '装货整柜').setProps({module:1}),


    Rt.page( "dedicatedLine/commission", "commission/commissionOrder/index", '委托单管理').setProps({module:3}),
    Rt.page( "dedicatedLine/inquiryRecord", "commission/inquiryRecord/index", '询价记录').setProps({module:3}),
    Rt.page( "dedicatedLine/quotation", "commission/quotationOrder/index", '报价单管理','d_quotation').setProps({module:3}),
    Rt.page( "dedicatedLine/report", "commission/report/index", '报关信息').setProps({module:3}),
    Rt.page( "dedicatedLine/billInfo", "commission/billInfo/index", '提单信息').setProps({module:3}),
    Rt.page( "dedicatedLine/measurements", "commission/measurements/index", '进仓信息').setProps({module:3}),
    Rt.page( "dedicatedLine/dstDeclaration", "commission/dstDeclaration/index", '目的国申报').setProps({module:3}),
    Rt.page( "dedicatedLine/costDetail", "commission/costDetail/index", '费用明细').setProps({module:3,sourceType:'ZX_COMMISSION_ORDER'}),
    Rt.page( "dedicatedLine/clearance", "commission/clearance/index", '清关信息').setProps({module:3}),


    Rt.page( "preface", "Preface", '首页'),
    Rt.page( "message", "Message", '消息中心'),

    Rt.page( "404", "404"),

    //设置
    Rt.page( "setting/company", "setting/company/index", '公司信息'),
    Rt.page( "setting/account", "setting/account/index", '人员账号')

]


/**
 * 主页子路由
 */
let homeChildren = [
    Rt.page("", "side/treeMenu", '').addChildren(...treeChildren),
    Rt.page( "example/flow", "examples/flow/index"),
]

/**
 * 一级路由
 */
const routes = [
    Rt.page( "/login", "Login"),
    Rt.page( "/", "Index"),
    Rt.page( "/home", "Home").addChildren(...homeChildren),
    {
        name: "auth",
        path: "/auth/:serviceCode",
        props: true,
        component: () => import("@/views/Auth.vue")
    },
    Rt.page( "/main", "Index"),
    Rt.page( "*", "404"),
].reverse();


Vue.use(Router);
export const router = new Router({
    routes,
    mode: 'history',
})

import menu from "@/common/menu";

router.beforeEach((to, from, next) => {
    menu.operations = []
    menu.operations.__init__ = false;
    window.rtMeta = to.meta;
    if (to.meta.title) {
        window.document.title = to.meta.title
    }
    next()
})



// WEBPACK FOOTER //
// ./src/router/index.js